import Vue from 'vue'

const state = {
  salesItems: {}
}

const mutations = {
  FETCH (state, salesItems) {
    state.salesItems = salesItems
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('sales-items')
      .then(response => {
        commit('FETCH', response.data)
      })
  }
}

const getters = {
  getSaleItems: state => saleID => {
    return Object.values(state.salesItems).filter(item => {
      return item.sale_id === saleID
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
